/**
 * InDeep-Net
 * Copyright (C) 2025
 * Authors: Fabien MAREUIL
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published
 * by the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <https://www.gnu.org/licenses/>.
 */
import React, { Component, useState } from 'react';
import axios from "axios";
import { WarningMessage } from '../Utils.js';
import AlertMessage from './Alert';

function ContactUs() {
  const [submitted, setSubmitted] = useState(false);
  const handleSubmission = async (event) => {

    event.preventDefault();

    const formData = new FormData();
    const message = document.getElementById("message").value;
    const email = document.getElementById("email").value;
    const subject = document.getElementById("subject").value;
    formData.append("email", email);
    formData.append("message", message);
    formData.append("subject", subject);
    await axios({
      method: "post",
      url: "/api/sendemail/",
      data: formData,
      headers: { "Content-Type": "application/json" },
    }).then(response => {
      setTimeout(() => { setSubmitted(true); }, 100);
    }

    ).catch(error => {
      WarningMessage(`${error.response.data.error} If problem persist please send an email to indeep-net@pasteur.fr`)
    })
  }

  return (<section className="col-start-2 col-span-4">
    <AlertMessage />
    <div className="py-8 lg:py-16 px-4 mx-auto">
      <h2 className="mb-4 text-4xl tracking-tight font-extrabold text-center text-gray-900 dark:text-white">Contact Us</h2>
      <p className="mb-8 lg:mb-16 font-light text-center text-gray-500 dark:text-gray-400 sm:text-xl">Got a technical issue? Want to send feedback about a beta feature? Let us know.</p>
      {submitted ? (
        <div className="text-center" >
          <h2 className="mb-4 text-xl tracking-tight font-extrabold text-gray-900 dark:text-white">Your message has been sended!</h2>
          <p className="text-gray-900 dark:text-white">Thank you for your message.</p>
        </div>) : (


        <form onSubmit={handleSubmission} method="POST" action="/api/sendemail" className="space-y-8">
          <div>
            <label htmlFor="email" className="block mb-2 text-sm font-medium text-gray-900 dark:text-gray-300">Your email</label>
            <input type="email" id="email" className="shadow-sm bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-green-500 focus:border-green-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-green-500 dark:focus:border-green-500 dark:shadow-sm-light" placeholder="name@indeep.com" required>
            </input>
          </div>
          <div>
            <label htmlFor="subject" className="block mb-2 text-sm font-medium text-gray-900 dark:text-gray-300">Subject</label>
            <input type="text" id="subject" className="block p-3 w-full text-sm text-gray-900 bg-gray-50 rounded-lg border border-gray-300 shadow-sm focus:ring-green-500 focus:border-green-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-green-500 dark:focus:border-green-500 dark:shadow-sm-light" placeholder="Let us know how we can help you" required>
            </input>
          </div>
          <div className="sm:col-span-2">
            <label htmlFor="message" className="block mb-2 text-sm font-medium text-gray-900 dark:text-gray-400">Your message</label>
            <textarea id="message" rows="6" className="block p-2.5 w-full text-sm text-gray-900 bg-gray-50 rounded-lg shadow-sm border border-gray-300 focus:ring-green-500 focus:border-green-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-green-500 dark:focus:border-green-500" placeholder="Leave a comment..."></textarea>
          </div>
          <button type="submit" className="py-3 px-5 text-sm font-medium text-center text-white rounded-lg bg-green-700 sm:w-fit hover:bg-green-800 focus:ring-4 focus:outline-none focus:ring-green-300 dark:bg-green-600 dark:hover:bg-green-700 dark:focus:ring-green-800">Send message</button>
        </form>

      )
      }
    </div>
  </section >)
}

class Contact extends Component {

  render() {


    return (
      <div id="main"
        className="grid md:grid-flow-col-dense sm:grid-flow-row-dense grid-cols-6 gap-4">
        <ContactUs />



      </div>
    );
  }
}

export default Contact;